import { useContext } from 'react';

import { FilterSlicesContext } from './context';

export const useFilterSlices = () => {
  const { slices } = useContext(FilterSlicesContext);

  return slices;
};
